import CountryDetailApp from "Country/Detail/App";
import CountryListApp from "Country/List/App";
import {
  type RouteObject,
} from "react-router";

declare let viewModel: any;

export const countryRoute: RouteObject = {
  path: "country",
  children: [{
    index: true,
    loader: () => viewModel,
    Component: CountryListApp,
  }, {
    path: ":key",
    loader: () => viewModel,
    Component: CountryDetailApp,
  }]
};